define([
    "jquery",
    "underscore",
    "marionette",
    "views/common/chartjs_view",
    "views/common/chartjs_utils",
    "views/common/chartjs_options",
    "bootstrap.datepicker"
], function($, _, Marionette, ChartView, chartUtils, chartOptions){
    return Marionette.LayoutView.extend({
        el: '#content_layout',

        ui: {
            'startDailyDatepicker': '#datetimepicker_daily_start',
            'endDailyDatepicker': '#datetimepicker_daily_end',
            'startMonthlyDatepicker': '#datetimepicker_monthly_start',
            'endMonthlyDatepicker': '#datetimepicker_monthly_end',
            'dailyFilters': '.filter-daily',
            'monthlyFilters': '.filter-monthly',
            'serversList' : "#servers_list",
        },

        regions: {
            'chart': '#chart',
            'chart2': '#chart2'
        },

        events: {
            'change @ui.serversList': function(e){
                if(e) e.preventDefault();
                window.location.href = window.baseUrl + "/report/commission_report/" + this.ui.serversList.val();
            },
            'dp.change @ui.endDailyDatepicker': function(e) {
                const endDate = $(this.ui.endDailyDatepicker).find('input').val();
                const startDate = new Date(endDate);
                startDate.setDate(startDate.getDate() - 29);
                $(this.ui.startDailyDatepicker).data('DateTimePicker').date(startDate);
                this.reloadDaily();
            },
            'dp.change @ui.endMonthlyDatepicker': function(e) {
                const endDate = $(this.ui.endMonthlyDatepicker).find('input').val();
                const startDate = new Date(endDate);
                startDate.setMonth(startDate.getMonth() - 11);
                $(this.ui.startMonthlyDatepicker).data('DateTimePicker').date(startDate);
                this.reloadMonthly();
            },
        },

        reloadDaily: function(e) {
            if(this.chartView === undefined) return;
            this.chartView.reload();
        },

        reloadMonthly: function(e) {
            if(this.monthlyChartView === undefined) return;
            this.monthlyChartView.reload();
        },

        initialize: function(){
            this.bindUIElements();

            var that = this;

            this.ui.startDailyDatepicker.datetimepicker({ format: 'YYYY-MM-DD' });
            this.ui.endDailyDatepicker.datetimepicker({ format: 'YYYY-MM-DD' });
            this.ui.startMonthlyDatepicker.datetimepicker({ format: 'YYYY-MM' });
            this.ui.endMonthlyDatepicker.datetimepicker({ format: 'YYYY-MM' });

            const newDate = new Date();
            const dailyDateStr = [newDate.getFullYear(), newDate.getMonth() + 1, newDate.getDate()].join('-');
            const monthlyDateStr = [newDate.getFullYear(), newDate.getMonth() + 1].join('-');
            $(this.ui.endDailyDatepicker).data('DateTimePicker').date(dailyDateStr);
            $(this.ui.endMonthlyDatepicker).data('DateTimePicker').date(monthlyDateStr);

            this.chartView = new ChartView({
                ajax: {
                    url: "/rest_report/commission_report_daily_chart",
                    method: "POST",
                    prepareData: function () {
                        const data = {};
                        that.ui.dailyFilters.each(function(){
                            data[$(this).attr("name")] = $(this).val();
                        });
                        return data;  
                    },
                    parseChartData: function (data) {
                        const clonedData = { data: [...data.data].reverse(), legend: [...data.legend].reverse()};
                        return {
                            labels: clonedData.legend,
                            datasets: [
                                {
                                    ...chartOptions.barChartDatasetOptions,
                                    label: "Daily commission",
                                    data: clonedData.data.map(el => +el),
                                },
                            ],
                        };
                    },
                },
                chartType: "bar",
                chartOptions: $.extend(true, {}, chartOptions.barChartOptions, {
                    scales: { y: { title: { text: "Daily commission" } } },
                    plugins: { tooltip: { external: chartUtils.customTooltip({ label: "Commission: " }) } },
                }),
                chartPlugins: [chartUtils.MirrorEffect],
                pagination: {
                    length: 30,
                    nextPagePosition: "left",
                },
                datepickerPagination: {
                    onPrevious: function () {
                        const currentDate = $(that.ui.endDailyDatepicker).find('input').val();
                        const newDate = new Date(currentDate);
                        newDate.setDate(newDate.getDate() + 1);
                        const dateStr = [newDate.getFullYear(), newDate.getMonth() + 1, newDate.getDate()].join('-');
                        $(that.ui.endDailyDatepicker).data('DateTimePicker').date(dateStr);
                    },
                    onNext: function () {
                        const currentDate = $(that.ui.endDailyDatepicker).find('input').val();
                        const newDate = new Date(currentDate);
                        newDate.setDate(newDate.getDate() - 1);
                        const dateStr = [newDate.getFullYear(), newDate.getMonth() + 1, newDate.getDate()].join('-');
                        $(that.ui.endDailyDatepicker).data('DateTimePicker').date(dateStr);
                    },
                }
            });
            this.showChildView('chart', this.chartView);

            this.monthlyChartView = new ChartView({
                ajax: {
                    url: "/rest_report/commission_report_monthly_chart",
                    method: "POST",

                    prepareData: function () {
                        const data = {};
                        that.ui.monthlyFilters.each(function(){
                            data[$(this).attr("name")] = $(this).val();
                        });
                        return data;  
                    },
                    parseChartData: function (data) {
                        const clonedData = { data: [...data.data].reverse(), legend: [...data.legend].reverse() };
                        return {
                            labels: clonedData.legend,
                            datasets: [
                                {
                                    ...chartOptions.barChartDatasetOptions,
                                    label: "Monthly commission",
                                    data: clonedData.data.map((el) => +el),
                                },
                            ],
                        };
                    },
                },
                chartType: "bar",
                chartOptions: $.extend(true, {}, chartOptions.barChartOptions, {
                    scales: { y: { title: { text: "Monthly commission" } } },
                    plugins: { tooltip: { external: chartUtils.customTooltip({ label: "Commission: " }) } },
                }),
                chartPlugins: [chartUtils.MirrorEffect],
                pagination: {
                    length: 12,
                    nextPagePosition: "left",
                },
                datepickerPagination: {
                    onPrevious: function () {
                        const currentDate = $(that.ui.endMonthlyDatepicker).find('input').val();
                        const newDate = new Date(currentDate);
                        newDate.setMonth(newDate.getMonth() + 1);
                        const dateStr = [newDate.getFullYear(), newDate.getMonth() + 1].join('-');
                        $(that.ui.endMonthlyDatepicker).data('DateTimePicker').date(dateStr);
                    },
                    onNext: function () {
                        const currentDate = $(that.ui.endMonthlyDatepicker).find('input').val();
                        const newDate = new Date(currentDate);
                        newDate.setMonth(newDate.getMonth() - 1);
                        const dateStr = [newDate.getFullYear(), newDate.getMonth() + 1].join('-');
                        $(that.ui.endMonthlyDatepicker).data('DateTimePicker').date(dateStr);
                    },
                }
            });
            this.showChildView('chart2', this.monthlyChartView);
        }
    });
});
